import React from 'react';
import { useBranding } from 'src/branding/BrandingContextProvider';
import { ServiceRequestFilters } from 'src/pages/ServiceRequests/CustomHooks/useServiceRequestFilters';
import StatusIcon from 'src/components/StatusIcon/StatusIcon';
import { getStatusConfigs, StatusConfig } from 'src/utils/statusUtils';
import { useStatusLabelResolver } from 'src/utils/serviceRequestStatus/useStatusLabelResolver';
import Card from 'src/components/Card';
import Status from 'src/components/Status';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './StatusOverviewCard.scss';

const toggleArrayState = (state: any, newValue: any) => {
  let newState: any = state ?? [];
  return newState.includes(newValue)
    ? newState.filter((s: any): boolean => s !== newValue)
    : newState.concat(newValue);
};

interface StatusOverviewCardProps {
  serviceRequestOverview: any;
  onSelectStatus: () => void;
  loading?: boolean;
  filters: ServiceRequestFilters;
  applyFilter: (key: string, data: any) => void;
}

const StatusOverviewCard = ({
  serviceRequestOverview,
  onSelectStatus,
  loading = false,
  filters,
  applyFilter,
}: StatusOverviewCardProps) => {
  const { branding } = useBranding();
  const resolveStatusLabel = useStatusLabelResolver();
  const { Statuses } = filters ?? {};

  const handleSelectStatus = (status: any) => {
    const newStatuses: any = toggleArrayState(Statuses, status);
    applyFilter('Statuses', newStatuses);
    onSelectStatus();
  };

  const statusConfigs: StatusConfig[] = getStatusConfigs(
    serviceRequestOverview
  );

  return (
    <div className="statusOverviewCard">
      <Card
        title="Status Overview"
        body={
          <div className="statusGrid">
            {statusConfigs.map((statusConfig: StatusConfig, index: number) => (
              <div
                key={index}
                className={`statusItem compact ${
                  Statuses?.includes(statusConfig.label) ? 'selected' : ''
                }`}
                onClick={() => handleSelectStatus(statusConfig.label)}
              >
                <div className="statusContent">
                  <Status
                    icon={
                      <StatusIcon
                        status={statusConfig.label}
                        showLabel={false}
                        size="medium"
                        className="overview-status-icon"
                      />
                    }
                    label={resolveStatusLabel(statusConfig.label)}
                  />
                </div>
                <div
                  className="statusCount"
                  style={{
                    color: branding?.colours?.text?.emphasis ?? undefined,
                  }}
                >
                  {loading ? (
                    <Skeleton variant="text" width="1.8rem" />
                  ) : (
                    statusConfig.count
                  )}
                </div>
              </div>
            ))}
          </div>
        }
      />
    </div>
  );
};

export default StatusOverviewCard;
